import { axiosBase, errorHandler } from "./axios";

const getPreference = () => {
  return axiosBase.get("common/preference/view")
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const getPreferenceByPhone = (phoneNumber: string) => {
  return axiosBase.get(`auth/preferenceByPhone?phoneNumber=${phoneNumber}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const savePreference = (data: any) => {
  return axiosBase.post("common/preference/save", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

export const preferenceService = {
  getPreference,
  getPreferenceByPhone,
  savePreference,
};
